export const SET_VALUE = 'SET_VALUE';

interface FormsState {
  forms: {
    [index: string]: {
      toSend: any;
      required: boolean;
      valid: boolean;
    };
  };
}

export const dataToSendInitialState: FormsState = { forms: {} } as any;

export const dataToSendReducer = (state: FormsState, action: any): FormsState => {
  switch (action.type) {
    case SET_VALUE: {
      const { key, data, index } = action.payload;
      if (key !== 'forms') return state;
      return {
        ...state,
        forms: {
          ...state.forms,
          [index]: data,
        },
      } as any;
    }
    default:
      return state;
  }
};
